import {inject, Injectable} from '@angular/core';
import {FileRef, FileStorageContextPort} from '@shared/application/ports/context/file-storage-context.port';
import {UuidPort} from '@shared/application/uuid/uuid.port';

@Injectable({providedIn: 'root'})
export class FileContextAdapter implements FileStorageContextPort {

  public data: Map<string, FileRef> = new Map<string, FileRef>();

  private uuidAdapter: UuidPort = inject(UuidPort);

  public set(ref: FileRef): FileRef {
    const id = ref.id ?? this.uuidAdapter.generate();
    this.data.set(id, {...ref, id: id});
    return {...ref, id: id};
  }

  public get(id: string): FileRef | null {
    const file = this.data.get(id);
    return file ?? null;
  }

  public del(id: string): void {
    this.data.delete(id);
    return;
  }

  public clear(): void {
    this.data.clear();
    return;
  }

}
